import React from "react";
import { Alert, Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicAlerts = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic alerts
        </Typography>

        <Typography variant="body1">
          The alert offers four severity levels that set a distinctive icon and
          color.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '            <Alert severity="error">\n' +
              "              This is an error alert — check it out!\n" +
              "            </Alert>\n" +
              '            <Alert severity="warning">\n' +
              "              This is a warning alert — check it out!\n" +
              "            </Alert>\n" +
              '            <Alert severity="info">This is an info alert — check it out!</Alert>\n' +
              '            <Alert severity="success">\n' +
              "              This is a success alert — check it out!\n" +
              "            </Alert>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert severity="error">
                This is an error alert — check it out!
              </Alert>
              <Alert severity="warning">
                This is a warning alert — check it out!
              </Alert>
              <Alert severity="info">
                This is an info alert — check it out!
              </Alert>
              <Alert severity="success">
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicAlerts;
